<template>
  <div class="navigation-breadcrumb">
    <v-breadcrumbs divider="/">
      <v-breadcrumbs-item
        v-for="item in items"
        :key="item.name"
        :to="item.path">
        {{ item.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  name: 'NavigationBreadcrumb',
  data() {
    return {
      routes: this.$route.matched,
    };
  },
  computed: {
    items() {
      return this.routes.map(route => ({
        ...route,
      }));
    },
  },
};
</script>

<style scoped lang="scss">
.navigation-breadcrumb {
  > .breadcrumbs {
    padding: 16px 16px 14px;
    margin: auto;
    border-bottom: 1px solid #f2f2f2;
  }
}
</style>
